module.exports = __webpack_public_path__ + "static/media/marker1.ff16441f.svg";